import { decryptToken } from "../utils/getToken";
import { API_BASE_URL } from "src/config/apiBase";
import TasksPage from "../../shared/tasks/components/TasksPage";
import TaskModal from "./TaskModal";
import TaskModalEdit from "./TaskModalEdit";
import TaskHistory from "./TaskHistory";

const Task = () => (
    <TasksPage
        role="staff"
        apiUrl={API_BASE_URL}
        getToken={() => decryptToken("accessToken") || ""}
        TaskModal={TaskModal}
        TaskModalEdit={TaskModalEdit}
        TaskHistory={TaskHistory}
        EmptyStateBlock={null}
    />
);

export default Task;
